import React from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { useComplianceCaseContext } from "../../../entrypoints/ComplianceCaseContext";
import { ButtonWrapper } from "../../common/ButtonWrapper";
import { ProfileStatusBadge } from "../../ProfileStatusBadge";
import { ProfileStatus } from "../../ProfileStatusBadge/types";
import { ProfileActionOverviewItemProps } from "../types";
import { buttonStyle, clickableCard, profileActionOverviewItem } from "./style_vanilla.css";

export const ProfileActionOverviewItem: React.FC<ProfileActionOverviewItemProps> = ({
  title,
  subTitle,
  buttonType,
  buttonEnabled,
  buttonTooltip,
  onClick,
  warning,
  status = null,
}: ProfileActionOverviewItemProps) => {
  const { enableLPUXv2 } = useComplianceCaseContext();
  const testIdPrefix = title.toLowerCase();

  const cardContent = (
    <>
      <Flex flexDirection="column">
        <Text variant="h4" data-testid={`${testIdPrefix}-title`}>
          {title}
        </Text>
        <Text variant="secondary-md">{subTitle}</Text>
      </Flex>
      <Flex>
        {enableLPUXv2 ? (
          <Flex alignItems="center" gap={Sizes.SM}>
            {status && <ProfileStatusBadge status={status} />}
            <Icon
              type={status == ProfileStatus.DetailsPending ? "lock" : "chevron-right"}
              size="medium"
              color={
                status == ProfileStatus.DetailsPending ? Colors.Neutral500 : Colors.Neutral800
              }
            />
          </Flex>
        ) : (
          <ButtonWrapper tooltip={buttonTooltip} id="help_indicator" disabled={!buttonEnabled}>
            <Flex data-testid={`${testIdPrefix}-warning`}>{warning}</Flex>
            <Button
              disabled={!buttonEnabled}
              className={buttonStyle}
              variant={buttonType === "start" ? "primary" : "neutral"}
              onClick={onClick}
              data-testid={`${testIdPrefix}-button`}
            >
              {buttonType === "start" ? "Start" : "Edit"}
            </Button>
          </ButtonWrapper>
        )}
      </Flex>
    </>
  );

  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      flexWrap={"wrap"}
      className={enableLPUXv2 && buttonEnabled ? clickableCard : profileActionOverviewItem}
      data-testid={`overview-item-${testIdPrefix}`}
      onClick={enableLPUXv2 && buttonEnabled ? onClick : undefined}
    >
      {cardContent}
    </Flex>
  );
};
